module.exports = __webpack_public_path__ + "media/images/bill-6c81b32ed3933469b8875b3427a2d8d3.png";